<div *ngIf="captchaBase64Url" class="field">
    <img [src]="captchaBase64Url" />
    <a href="javascript:void(0);" (click)="reload()" class="hyperlink">{{ 'TryANewImage' | translate }}</a>
    <label class="label lm-captcha-label">{{ 'EnterTextInImage' | translate }}</label>
    <input type="text" [(ngModel)]="captchaValue" [ngClass]="{'error': isValid === false}" />
</div>

